/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { AUTOMATION, DAYS, ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, MONTH, OFFSET, PROGRAMSCHEDULEDRAFT_SAVETYPE, SCHEDULETYPE, TOAST_TYPES } from "../../../framework/constant/constant";
import { useTranslation } from "../../../locale/useTranslation";
import { utility } from "../../../framework/utility/utilityProvider";
import { Menubar } from 'primereact/menubar';
import { UserPreference } from "../../userPreference/UserPreference";
import CheckListPreference from "../../CheckList/CheckListPreference";
import contextMenuItem from "../../../components/contextMenuItem";
import * as API from "../../../framework/API/api";
import OpenScheduleDraftDialog from "./OpenScheduleDraftDialog";
import AddProgramSchedulePopup from "./AddProgramSchedulePopup";
import ScheduleMAMAssetReportPopup from "./ScheduleMAMAssetReportPopup";
import { PlanningHelper } from "../../Planning/helper/PlanningHelper";
import ExportEPGReport from "../../Export/ExportEPGReport";
import ToastNotification from "../../../components/ToastNotification";

export const ScheduleHeaderNew = (props) => {

    const {
        date,
        selectedChannel,
        channelList,
        handleFilterDialog,
        onDateChange,
        onScheduleRefresh,
        onDeleteAllFooter,
        onMatchPreviousDayEndTime,
        onSchedulePreference,
        onDeleteAllSecondary,
        onAppleStyleSheet,
        onShowGlobalReplacement,
        onSetDoOnCheckList,
        onExportSchedule,
        onExportAnnouncement,
        statusInfo,
        onFillUnderOverRun,
        scheduleTimeInfo,
        schedulerData,
        onAutomaticBreakDistribution,
        selectedState,
        lock,
        onScheduleLock,
        lockStatus,
        onAutoFillBookedCommercial,
        onReturnSlotDateTimeToPlannedNominalTime,
        showBreakOnly,
        setShowBreakOnly,
        onAutoPlotPromo,
        clientInfo,
        onResetAutoFillPlaylistChildren,
        setShowGoToSchedulePopup,
        onHeaderExpandChange,
        onCut,
        onCopy,
        onPaste,
        onDelete,
        deleteSelectedSecondaryEvent,
        showSecondaryEventOverviewDialogProp,
        showInsertBreakPopup,
        onRevertVirtualSegmentation,
        handleLiveEventPopup,
        handleScheduleDraftPopup,
        loadDraftdata,
        setIsDraftMode,
        isDraftMode,
        onOpenPlanning,
        onCreateFastPlaylist,
        onManageUnderOverRunForSelectedHeader,
        onResetSchedule,
        autoFillPlaylistWithMusic,
        onAutoSchedule,
        onApplySCTEMarkers,
        onDeleteAllSCTEMarkers,
        onImportCommercials,
        onExecutePromoCampaign,
        onReSyncHeaderSegments,
        onExportCNBCPlaylist

    } = props;

    // const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const applicationConfigurationValue = utility.getValue(LOCALSTORAGE_KEY.applicationConfiguration);
    const enableScheduleInsertLiveEvent = applicationConfigurationValue ? (applicationConfigurationValue.find(x => x.Key == 'EnableScheduleInsertLiveEvent')?.Value ?? false) : false;
    // const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
    // const offsetTime = offSetHours * 3600000;

    const offSetHours = new Date(PlanningHelper.getDayStartTime([selectedChannel]) ?? 0).getUTCHours();
    let mainTimeZone = PlanningHelper.getMainTimeZone([selectedChannel]);


    //ALWAYS SUBTRACT OFFSET
    const offsetTime = (offSetHours * 3600000) - (mainTimeZone.IsNegativeOffset ? -mainTimeZone.Offset : mainTimeZone.Offset);

    const lang = useTranslation();

    const date_ttc_milisecond = date.getTime();//   utility.getLocalDateTimeToUtcMiliseconds(date)

    const [showPreferences, _setShowPreferences] = useState(false);
    const [draftData, setDraftData] = useState(null);
    const showPreferencesRef = useRef(false);
    const setShowPreferences = (value) => {
        showPreferencesRef.current = value;
        _setShowPreferences(value);
    }

    const [showCheckListPreference, setShowCheckListPreference] = useState(false);
    const [showOpenDraftPopup, setShowOpenDraftPopup] = useState(false);
    const [showAddProgramPopup, setShowAddProgramPopup] = useState(false);
    const [showScheduleMAMAssetReportPopup, setShowScheduleMAMAssetReportPopup] = useState(false);
    const [showEPGPopup, setShowEPGPopup] = useState(false);



    useEffect(() => {
    }, []);

    const otherIconStyles = { textAlign: "center", fontSize: "1.12em", color: "#444746", size: "0.6em", cursor: "pointer" };

    const onExport = (automation, doSftp = false, isPartial = false, isDeliver = false, withSCTE = false, isCommercial = false) => {

        if (selectedChannel.isCheckListMandatory) {
            onSetDoOnCheckList();
            return;
        }

        onExportSchedule({
            automation,
            channel: selectedChannel,
            doSftp,
            isPartial,
            isDeliver,
            withSCTE,
            isCommercial
        });

    }

    const handleShowLogs = () => {
        const path = ('/home/AuditLog' + "?module=" + MODULE.SCHEDULING + "&sloatDateTime=" + date?.getTime() + "&channel=" + selectedChannel?.SID + "&title=" + selectedChannel?.FullChannelName)
        window.open(path, "MyTargetWindowName");
    }

    const onCloseUserPrefence = (isSave) => {
        setShowPreferences(!showPreferences);
        console.log(isSave);
        if (isSave == true) {
            onScheduleRefresh();
        }
    }

    const handlePublishDraftData = async () => {


        //VALIDATION
        const currentDateMillisec = utility.getLocalDateTimeToUtcMiliseconds(new Date());

        if (currentDateMillisec >= draftData.ScheduleDate) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.restore_schedule_draft_validation_error_message });
            return;
        }


        let payload = {
            data: draftData
        }

        let draftPublishRes = await API.publishProgramScheduleDraft(payload);

        if (draftPublishRes.success) {
            setIsDraftMode(false);
            setDraftData(null);
            onScheduleRefresh();
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: draftPublishRes.message });

            //CAPTURE LOG HERE
            let logData = {
                event: LOGEVENT.RESTORE_SCHEDULE_DRAFT,
                module: MODULE.SCHEDULING,
                data: draftData,
                message: `Schedule Draft Restore from ${draftData.SaveType == PROGRAMSCHEDULEDRAFT_SAVETYPE.BOTH ? 'database/file' : draftData.SaveType == PROGRAMSCHEDULEDRAFT_SAVETYPE.FILE ? 'file' : 'database'}`
            };

            API.SaveLogs(logData);


        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: draftPublishRes.message });
        }

    }

    const handleOpenScheduleDraftPopup = () => {
        setShowOpenDraftPopup(!showOpenDraftPopup);
    }

    const items = [

        //FILE MENU
        {
            label: lang.file_menu_label,
            items: [
                {
                    icon: 'pi pi-plus',
                    label: lang.new_schedule_menu_label,
                    tooltip: 'Open Schedule In New Window',
                    command: () => {
                        window.open("/home/Scheduling", "_blank");
                    },
                    template: contextMenuItem,
                },
                {
                    icon: 'pi pi-folder-open',
                    label: lang.open_draft_menu_label,
                    command: async () => {
                        handleOpenScheduleDraftPopup();
                    },
                    template: contextMenuItem,
                },
                {
                    icon: 'pi pi-save',
                    label: lang.save_as_draft_menu_label,
                    command: () => {
                        handleScheduleDraftPopup();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lock ? lang.unlock_schedule_menu_label : lang.lock_schedule_menu_label,
                    icon: lock ? 'fa fa-lock fa-lg ' : 'fa fa-lock-open',
                    iconColor: lockStatus.isSelfLocked ? 'green' : lock ? '#B70404' : null,
                    title: lock && lang.locked_by_label + lockStatus.lockedBy.name,
                    command: () => {
                        onScheduleLock();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.open_planning_menu_label,
                    icon: 'pi pi-desktop',
                    shortcut: 'F12',
                    command: () => {
                        onOpenPlanning();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.show_logs_menu_label,
                    icon: 'pi pi-database',
                    command: () => {
                        handleShowLogs();
                    },
                    template: contextMenuItem,
                },
                {
                    icon: 'pi pi-qrcode',
                    label: lang.mam_asset_report,
                    command: () => {
                        setShowScheduleMAMAssetReportPopup(true);
                    },
                    template: contextMenuItem,
                },
                {
                    icon: 'pi pi-upload',
                    label: lang.import_commercials,
                    command: () => {
                        onImportCommercials();
                    },
                    template: contextMenuItem,
                },
                {
                    icon: 'pi pi-download',
                    label: lang.export_commercials_label,
                    command: () => {
                        onExport(AUTOMATION.EXCEL, false, false, false, false, true);
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.export_menu_label,
                    icon: 'pi pi-download',
                    items: [
                        {
                            label: lang.export_playlist_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExport(selectedChannel.Automation.SID, false, false, false, true);
                            },
                            template: contextMenuItem,
                        },
                        {
                            label: lang.export_partial_playlist_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExport(selectedChannel.Automation.SID, false, true);
                            },
                            template: contextMenuItem,
                        },
                        {
                            label: selectedChannel?.Automation?.SID == AUTOMATION.MULTITV_V2 ||
                                selectedChannel?.Automation?.SID == AUTOMATION.SI_MDA ? lang.push_playlist_menu_label : lang.export_and_deliver_playlist_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExport(selectedChannel.Automation.SID, false, false, true, true);
                            },
                            template: contextMenuItem,
                        },
                        {
                            label: lang.export_sftp_playlist_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExport(selectedChannel.Automation.SID, true);
                            },
                            template: contextMenuItem,
                        },
                        {
                            label: lang.download_pdf_menu_label,
                            icon: 'pi pi-file-pdf',
                            command: () => {
                                onExport(AUTOMATION.PDF)
                            },
                            template: contextMenuItem,
                        },
                        {
                            label: lang.export_excel_menu_label,
                            icon: 'pi pi-file-excel',
                            command: () => {
                                onExport(AUTOMATION.EXCEL, false, false, false, true)
                            },
                            template: contextMenuItem,
                        },
                        // {
                        //     label: "Export CNBC Playlist",
                        //     icon: 'pi pi-file-excel',
                        //     command: () => {onExportCNBCPlaylist();},
                        //     template: contextMenuItem,
                        // },
                        {
                            label: lang.export_itxml_menu_label,
                            icon: 'pi pi-file-arrow-up',
                            command: () => {
                                onExport(AUTOMATION.ROCK_ITXMML, false, false, false, true)
                            },
                            template: contextMenuItem,
                        },
                        {
                            label: lang.export_announcement_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExportAnnouncement();
                            },
                            template: contextMenuItem,
                        },
                        {
                            label: lang.export_imagine_playlist_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExport(AUTOMATION.IMAGINE);
                            },
                            template: contextMenuItem,
                        },
                        company && company.Name && company.Name.toLowerCase() == 'rotana' && {
                            label: lang.export_epg_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                setShowEPGPopup(true);
                            },
                            template: contextMenuItem,
                        },
                        clientInfo?.ClientName?.toLowerCase() == 'action24' && {
                            label: lang.export_ross_playlist_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExport(AUTOMATION.ROSS);
                            },
                            template: contextMenuItem,
                        },
                        clientInfo?.ClientName?.toLowerCase() == 'kbc' && {
                            label: lang.export_jazler_commercial_menu_label,
                            icon: 'pi pi-download',
                            command: () => {
                                onExport(AUTOMATION.JAZLERCOMMERCIALBREAK)
                            },
                            template: contextMenuItem,
                        },
                    ].filter(Boolean)
                },

            ]
        },
        //EDIT MENU
        {
            label: lang.edit_menu_label,
            items: [
                {
                    label: lang.cut_menu_label,
                    icon: 'fa fa-cut',
                    shortcut: 'Ctrl + X',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onCut();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.copy_menu_label,
                    icon: 'pi pi-copy',
                    shortcut: 'Ctrl + C',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onCopy();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.paste_menu_label,
                    icon: 'fa fa-paste',
                    shortcut: 'Ctrl + V',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onPaste();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.delete_menu_label,
                    icon: 'pi pi-trash',
                    shortcut: 'del',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onDelete();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.insert_break_menu_label,
                    icon: 'pi pi-envelope',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: (e) => {
                        showInsertBreakPopup(e);
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.find_and_replace_menu_label,
                    icon: 'pi pi-globe',
                    shortcut: 'Ctrl + H',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onShowGlobalReplacement();
                    },
                    template: contextMenuItem,
                },
                enableScheduleInsertLiveEvent && {
                    label: lang.insert_live_event_menu_label,
                    icon: 'pi pi-eye',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        handleLiveEventPopup();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.revert_virtual_segment_menu_label,
                    icon: 'pi pi-box',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onRevertVirtualSegmentation();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.delete_all_footer_menu_label,
                    icon: 'pi pi-trash',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onDeleteAllFooter();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.match_prev_day_end_time_menu_label,
                    icon: 'pi pi-clock',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onMatchPreviousDayEndTime(scheduleTimeInfo);
                    },
                    template: contextMenuItem,
                },
                {
                    icon: 'pi pi-server',
                    label: lang.add_program_menutext,
                    command: () => {
                        setShowAddProgramPopup(true);
                    },
                    template: contextMenuItem,
                },

            ].filter(Boolean)
        },
        //VIEW MENU
        {
            label: lang.view_menu_label,
            items: [
                {
                    icon: 'pi pi-link',
                    label: lang.go_to_menu_label,
                    command: () => {
                        setShowGoToSchedulePopup(true);
                    },
                    shortcut: 'Ctrl + B',
                    template: contextMenuItem,
                },
                {
                    icon: 'pi pi-refresh',
                    label: lang.refresh_schedule_menu_label,
                    disabled: isDraftMode,
                    shortcut: 'F5',
                    command: () => {
                        onScheduleRefresh();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.show_breaks_only_menu_label,
                    icon: showBreakOnly ? 'pi pi-eye-slash' : 'pi pi-eye',
                    iconColor: showBreakOnly ? '#B70404' : 'black',
                    command: () => {
                        setShowBreakOnly(!showBreakOnly)
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.expand_menu_label,
                    icon: 'pi pi-arrows-v',
                    shortcut: 'Ctrl +',
                    command: () => {
                        onHeaderExpandChange({ target: { value: true } });
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.collapse_menu_label,
                    icon: 'pi pi-minus',
                    shortcut: 'Ctrl -',
                    command: () => {
                        onHeaderExpandChange({ target: { value: false } });
                    },
                    template: contextMenuItem,
                },
            ]
        },
        //SECONDARY EVENTS MENU
        {
            label: lang.secondary_events_menu_label,
            items: [
                {
                    label: lang.delete_all_menu_label,
                    icon: 'pi pi-trash',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onDeleteAllSecondary();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.delete_selected_menu_label,
                    icon: 'pi pi-trash',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        deleteSelectedSecondaryEvent();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.se_overview_menu_label,
                    icon: 'pi pi-book',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        showSecondaryEventOverviewDialogProp();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.apply_style_sheet_menu_label,
                    icon: 'pi pi-palette',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onAppleStyleSheet();
                    },
                    template: contextMenuItem,
                },
            ]
        },
        //RUN MENU
        {
            label: lang.run_menu_label,
            items: [
                {
                    label: `Auto Schedule Playlist`,
                    icon: 'pi pi-flag-fill',
                    tooltip: `Automatically create whole complete playlist.`,
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onAutoSchedule();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.auto_fill_short_forms_menu_label,
                    icon: 'pi pi-angle-double-up',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    tooltip: 'Select promos from media library first then select this button to auto fill promo in schedule. either you can give weightage break wise or total play count',
                    command: () => {
                        onAutoPlotPromo();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.auto_fill_booked_spots_menu_label,
                    icon: 'pi pi-video',
                    tooltip: 'System will auto fill booked spots in schedule based on time range selected at the time of booking.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onAutoFillBookedCommercial();
                    },
                    template: contextMenuItem,
                },
                // {
                //     label: lang.execute_promo_campaigns_menu_label,
                //     icon: 'pi pi-arrow-circle-left',
                //     tooltip:'System will delete all the items from schedule except header and segments.',
                //     disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                //     command: () => {
                //         onExecutePromoCampaign();
                //     },
                //     template: contextMenuItem,
                // },
                {
                    label: lang.fill_playlist_menu_label,
                    icon: 'pi pi-list',
                    tooltip: 'System will fill schedule based on variations and default format selected to pack playlist with a click of a button.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onFillUnderOverRun(scheduleTimeInfo);
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.auto_fill_music_menu_label,
                    icon: 'fa fa-music fa-fw',
                    tooltip: 'System will fill schedule based on music category attached to every header.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        autoFillPlaylistWithMusic();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.create_fast_playlist_menu_label,
                    icon: 'pi pi-bolt',
                    tooltip: 'Create complete playlist for multiple days with a click of a button based on variations and format schedule configured to pack playlist.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onCreateFastPlaylist();
                    },
                    template: contextMenuItem,
                },
                //SCTE FUNCTIONALITY
                {
                    label: `Apply ${company?.Name?.toLowerCase() == "rock" ? lang.cue_tones_menu_label : lang.scte_markers_menu_label}`,
                    icon: 'pi pi-flag-fill',
                    tooltip: `Apply ${company?.Name?.toLowerCase() == "rock" ? 'Cue Tones' : 'SCTE Markers'} on complete playlist.`,
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onApplySCTEMarkers(selectedChannel);
                    },
                    template: contextMenuItem,
                },
                {
                    label: `Delete All ${company?.Name?.toLowerCase() == "rock" ? lang.cue_tones_menu_label : lang.scte_markers_menu_label}`,
                    icon: 'pi pi-flag',
                    tooltip: `Remove All ${company?.Name?.toLowerCase() == "rock" ? 'Cue Tones' : 'SCTE Markers'} from playlist.`,
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onDeleteAllSCTEMarkers();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.reset_auto_fill_menu_label,
                    icon: 'pi pi-undo',
                    tooltip: 'System will delete all the items from schedule which were filled using auto fill playlist or create fast playlist.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onResetAutoFillPlaylistChildren();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.reset_schedule_menu_label,
                    icon: 'pi pi-arrow-circle-left',
                    tooltip: 'System will delete all the items from schedule except header and segments.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onResetSchedule();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.sync_all_headers_segment_menu_label,
                    icon: 'pi pi-slack',
                    tooltip: "Header segments will be re-synced if they exist but are either unsynced or have changed.",
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onReSyncHeaderSegments();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.reset_header_to_nominal_menu_label,
                    icon: 'pi pi-clock',
                    tooltip: 'System will reset the start of each header to nominal start time set in planning module.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onReturnSlotDateTimeToPlannedNominalTime();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.create_automatic_breaks_menu_label,
                    icon: 'pi pi-desktop',
                    tooltip: 'System will create promos and commercial breaks based on break configuration master.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onAutomaticBreakDistribution();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.manage_underoverrun_schedule_menu_text,
                    icon: 'pi pi-list',
                    tooltip: 'System will fill under/over runs in schedule based on variations for selected headers only.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onManageUnderOverRunForSelectedHeader();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.check_lists_menu_label,
                    icon: 'pi pi-check-square',
                    tooltip: 'System will execute check lists based configured preference.',
                    disabled: isDraftMode || !lockStatus.canModify || !lockStatus.canModifyHeader,
                    command: () => {
                        onSetDoOnCheckList();
                    },
                    template: contextMenuItem,
                },
            ]
        },
        //SETTINGS MENU
        {
            label: lang.settings_menu_label,
            items: [


                {
                    label: lang.schedule_preference_menu_label,
                    icon: 'pi pi-cog',
                    command: () => {
                        onSchedulePreference();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.column_preference_menu_label,
                    icon: 'pi pi-pause',
                    command: () => {
                        onCloseUserPrefence();
                    },
                    template: contextMenuItem,
                },
                {
                    label: lang.checklist_preference_menu_label,
                    icon: 'pi pi-check-circle',
                    command: () => {
                        setShowCheckListPreference(true);
                    },
                    template: contextMenuItem,
                },
            ]
        },
        //LOCK ICON
        {
            icon: lock ? 'fa fa-lock fa-lg ' : 'fa fa-lock-open',
            iconColor: lockStatus.isSelfLocked ? 'green' : lock ? '#B70404' : null,
            title: lock && lang.locked_by_label + lockStatus.lockedBy.name,
            command: () => {
                onScheduleLock();
            },
            template: contextMenuItem,
        },

        //EXIT DRAFT
        isDraftMode && {
            label: lang.exit_draft_mode_menu_label,
            color: "red",
            command: () => {
                setIsDraftMode(false);
                setDraftData(null);
                onScheduleRefresh();
            },
            template: contextMenuItem,
        },
        //RESTORE DRAFT
        isDraftMode && {
            label: lang.restore_menu_label,
            color: "green",
            command: async () => {

                await handlePublishDraftData()

            },
            template: contextMenuItem,
        }
    ];

    return <>

        <div className="row mt-2 mb-3" style={{ fontFamily: "Roboto", width: "100%" }}>

            <div className="col-8" >
                <div className="flex-container" style={{ alignItems: "left" }}>
                    <div style={{ zIndex: 100 }}>
                        <h3 className="page-edit-title txt-color-bludeDark" style={{ margin: '0px 10px 0px 0px', fontSize: '18px' }}>
                            <i className="fa-regular fa-calendar-days" style={{ margin: '0px 5px 0px 0px' }}></i>{lang.schedule_header}<span style={{ color: "green", fontSize: "13px" }}>{isDraftMode && "- Draft Mode"}</span>
                        </h3>
                        <Menubar style={{ height: "40px", zIndex: 100, background: "transparent", border: "none", marginLeft: "-8px", padding: '8px 8px 16px 0px' }} model={items} />
                    </div>
                    {/* uncomment this section*/}
                    {/* <div title={lang.refresh_button_tooltip} className="iconBase">
                        <RefreshIcon style={otherIconStyles} onClick={onScheduleRefresh} />
                    </div> */}
                    {/* uncomment this section*/}
                    {/* <div title={lang.export_playlist_button_tooltip} className="iconBase">
                        <DownloadIcon style={otherIconStyles} onClick={() => {
                            onExport(selectedChannel.Automation.SID)

                        }} />
                    </div>
                    {clientInfo?.ClientName?.toLowerCase() == 'kbc' && <div title={lang.export_jazzler_automation_playlist} className="iconBase">
                        <DownloadForOfflineIcon style={otherIconStyles} onClick={() => {
                            onExport(AUTOMATION.JAZLERCOMMERCIALBREAK)
                        }} />
                    </div>}
                    <div title={lang.export_and_sftp_playlist_button_tooltip} className="iconBase">
                        <UploadIcon style={otherIconStyles} onClick={() => {
                            onExport(selectedChannel.Automation.SID, true)
                        }} />
                    </div> */}

                    {/* <div title={lang.export_planet_cast_button_tooltip} className="iconBase">
                            <AssignmentReturnedIcon style={otherIconStyles} onClick={() => onExport(selectedChannel.AutomationSID)} /> 
                        </div> */}

                    {/* uncomment this section*/}
                    {/* <div title={lang.download_pdf_button_tooltip} className="iconBase">
                        <PdfIcon style={otherIconStyles} onClick={() => onExport(AUTOMATION.PDF)} />
                    </div>

                    <div title={'Excel Export'} className="iconBase">
                        <DisabledByDefaultIcon style={otherIconStyles} onClick={() => onExport(AUTOMATION.EXCEL)} />
                    </div> */}

                    {/* onClick={() => onExport(AUTOMATION.AMAGI_AS_RUN)} className="iconBase fa fa-file-excel pb-2" style={{ ...otherIconStyles, display: 'flex', alignItems: 'center' }} */}
                    {/* <div title={lang.export_csv_button_tooltip} className="iconBase">
                        <ArticleIcon style={otherIconStyles} onClick={() => onExport(AUTOMATION.AMAGI_AS_RUN)} />
                    </div> */}

                    {/* uncomment this section*/}
                    {/* <div title={lang.open_planning_button_tooltip} className="iconBase">
                        <OpenIcon style={otherIconStyles} onClick={onOpenPlanning} />
                    </div> */}

                    {/* <div title={lang.delete_all_footer_button_tooltip} className="iconBase">
                        <DeleteFooterIcon style={otherIconStyles} onClick={onDeleteAllFooter} />
                    </div> */}

                    {/* <div title={lang.delete_All_secondary_events_button_tooltip} className="iconBase">
                        <DeleteAllSecondaryEventIcon style={otherIconStyles} onClick={onDeleteAllSecondary} />
                    </div> */}

                    {/* <div title={lang.apply_style_sheet_button_tooltip} className="iconBase">
                        <ApplyStyleSheetIcon style={otherIconStyles} onClick={onAppleStyleSheet} />
                    </div> */}

                    {/* <div title={lang.global_replacement_button_tooltip} className="iconBase">
                        <ChangeCircle style={otherIconStyles} onClick={onShowGlobalReplacement} />
                    </div> */}

                    {/* <div title={lang.check_list_button_tooltip} className="iconBase">
                        <AssignmentTurnedInIcon style={otherIconStyles} onClick={onSetDoOnCheckList} />
                    </div> */}

                    {/* <div title={lang.fill_under_run_button_tooltip} className="iconBase">
                        <FactCheckIcon style={otherIconStyles} onClick={onFillUnderOverRun} />
                    </div> */}

                    {/* <div title={lang.resetautofill_button_tooltip} className="iconBase">
                        <ResetAutoFillIcon style={otherIconStyles} onClick={onResetAutoFillPlaylistChildren} />
                    </div> */}

                    {/* <div title={lang.schedule_automatic_break_tooltip} className="iconBase">
                        <VideoSettingsIcon style={otherIconStyles} onClick={onAutomaticBreakDistribution} />
                    </div> */}

                    {/* <div title={lang.schedule_preference_button_tooltip} className="iconBase">
                        <SettingsSuggestIcon style={otherIconStyles} onClick={onSchedulePreference} />
                    </div> */}

                    {/* <div title={lang.schedule_autofill_button_tooltip} className="iconBase">
                        <FormatColorFill style={otherIconStyles} onClick={onAutoFillBookedCommercial} />
                    </div> */}

                    {/* <div title={lang.schedule_reset_all_header_to_nominal_start_time_button_tooltip} className="iconBase">
                        <ReturnToNominalTimeIcon style={otherIconStyles} onClick={onReturnSlotDateTimeToPlannedNominalTime} />
                    </div> */}

                    {/* <div title={lang.auto_plot_interstitial_label} className="iconBase">
                        <LocalDrinkIcon style={otherIconStyles} onClick={onAutoPlotPromo} />
                    </div> */}

                    {/* <div title={lang.export_announcement_tooltip} className="iconBase">
                        <CampaignIcon style={otherIconStyles} onClick={() => {
                            onExportAnnouncement()
                        }} />
                    </div> */}

                    {/* <div title={showBreakOnly ? lang.show_all_label : lang.show_break_only_label} className="iconBase" >
                        <i style={{ ...otherIconStyles, fontSize: "1em", size: "0.4em", color: showBreakOnly ? 'green' : 'black', transform: "rotate(90deg)" }} className={'fa fa-sliders'} onClick={() => setShowBreakOnly(!showBreakOnly)} />
                    </div> */}

                    {/* <div title={lang.show_logs_label} className="iconBase" >
                        <i style={{ ...otherIconStyles, fontSize: "0.9em", size: "0.4em", }} className={'fa fa-external-link'} onClick={handleShowLogs} />
                    </div> */}
                </div>

                <div className="headerPostion">

                    <span className="headerText p-1" >{lang.start_time_label} : </span>
                    <span className="headerText p-1" title={(scheduleTimeInfo.StartDateTime != scheduleTimeInfo.PreviousScheduleEndDateTime) && "Match Prev Day End Time"} onClick={() => (scheduleTimeInfo.StartDateTime != scheduleTimeInfo.PreviousScheduleEndDateTime) && onMatchPreviousDayEndTime(scheduleTimeInfo)} style={(scheduleTimeInfo.StartDateTime != scheduleTimeInfo.PreviousScheduleEndDateTime) ? { color: 'red', marginLeft: '-15px', cursor: 'pointer' } : { marginLeft: '-15px' }}>
                        {/* {utility.convertMilisecondsToStringWithFrames(scheduleTimeInfo.StartDateTime)} */}
                        {utility.getTimeByTimeZone(
                            scheduleTimeInfo.StartDateTime,
                            mainTimeZone?.IsNegativeOffset,
                            mainTimeZone?.Offset,
                            null,
                            true
                        )}
                    </span>

                    <span className="headerText p-1">{lang.end_time_label} :
                        {/* {utility.convertMilisecondsToStringWithFrames(scheduleTimeInfo.EndDateTime)} */}
                        {utility.getTimeByTimeZone(
                            scheduleTimeInfo.EndDateTime,
                            mainTimeZone?.IsNegativeOffset,
                            mainTimeZone?.Offset,
                            null,
                            true
                        )}
                    </span>
                    {!isDraftMode && <span className="headerText p-1">{lang.previous_day_end_time_label} :
                        {scheduleTimeInfo.PreviousScheduleEndDateTime == 0 ?
                            "NA" :
                            // utility.convertMilisecondsToStringWithFrames(scheduleTimeInfo.PreviousScheduleEndDateTime)
                            utility.getTimeByTimeZone(
                                scheduleTimeInfo.PreviousScheduleEndDateTime,
                                mainTimeZone?.IsNegativeOffset,
                                mainTimeZone?.Offset,
                                null,
                                true
                            )
                        }
                    </span>}
                </div>
            </div>

            <div className="col-2 pull-right">
                <input
                    type="search"
                    className="form-control shadow-inset-2 pt-0 pb-0 right ml-1"
                    id="search"
                    style={{ width: "200px" }}
                    aria-label="type 2 or more letters"
                    placeholder={lang.search_button_text}
                    onChange={props.onSearch}
                    onFocus={(e) => {
                        props.setOutSideFocus(true);
                    }}
                    onBlur={(e) => {
                        props.setOutSideFocus(false);
                    }}
                />
            </div>
            <div className="col" style={{ textAlign: "right", padding: '0px', margin: '0px' }}>


                <div className="row-reverse">
                    {isDraftMode ?
                        <div className="col">
                            <div className="row-reverse" style={{}}>
                                <span style={{ fontFamily: "Roboto", fontWeight: "bold", fontSize: "18px", color: "#4b4d4d" }} >{draftData?.Channel?.FullChannelName ?? ''} </span>
                            </div>
                            <div>
                                {/* Tuesday, January 5, 2022. */}
                                <span style={{ fontFamily: "Roboto", fontSize: "16px", color: "#4b4d4d" }}>{new Date(draftData.ScheduleDate).getUTCDate()} {MONTH[new Date(draftData.ScheduleDate).getUTCMonth()]} {new Date(draftData.ScheduleDate).getUTCFullYear()}, {DAYS[new Date(draftData.ScheduleDate).getDay()].SubName}</span>
                            </div>
                        </div> : <div className="col">
                            <div className="row-reverse" style={{}}>
                                <span onClick={handleFilterDialog} style={{ fontFamily: "Roboto", fontWeight: "bold", fontSize: "18px", color: "#4b4d4d", cursor: "pointer" }} >{selectedChannel.name} </span>
                            </div>
                            <div>
                                <span> <i className="fa-lg fa-solid fa-square-caret-left fa-md pt-1 mr-1 pointer" onClick={() => onDateChange(false)}></i> </span>
                                {/* Tuesday, January 5, 2022. */}
                                <span className="pointer" onClick={handleFilterDialog} style={{ fontFamily: "Roboto", fontSize: "16px", color: "#4b4d4d" }}>{date.getUTCDate()} {MONTH[date.getUTCMonth()]} {date.getUTCFullYear()}, {DAYS[date.getDay()].SubName}</span>
                                <span style={{ padding: '0px', margin: '0px', color: "#4b4d4d" }} />
                                <span> <i className="fa-lg fa-solid fa-square-caret-right fa-md pt-1 ml-1 pointer" onClick={() => onDateChange(true)}></i> </span>
                            </div>
                        </div>}
                </div>

            </div>

        </div>

        {showPreferences && <UserPreference entityName={ENTITYNAME.SCHEDULE_MAIN_GRID} handleClose={onCloseUserPrefence} />}
        {showCheckListPreference && <CheckListPreference closeForm={() => setShowCheckListPreference(false)} />}
        {showOpenDraftPopup && <OpenScheduleDraftDialog loadDraftdata={loadDraftdata} setIsDraftMode={setIsDraftMode} setDraftData={setDraftData} onClose={handleOpenScheduleDraftPopup} channelList={channelList} selectedChannel={selectedChannel} date={date} />}
        {showAddProgramPopup && <AddProgramSchedulePopup offsetTime={offsetTime} date={date} channel={selectedChannel} onClose={() => setShowAddProgramPopup(false)} onScheduleRefresh={onScheduleRefresh} schedulerData={schedulerData} />}
        {showScheduleMAMAssetReportPopup && <ScheduleMAMAssetReportPopup offsetTime={offsetTime} date={date} channel={selectedChannel} onClose={() => setShowScheduleMAMAssetReportPopup(false)} onScheduleRefresh={onScheduleRefresh} />}

        {showEPGPopup && <ExportEPGReport isFromSchedule={true} date={date} channel={selectedChannel} onClose={() => setShowEPGPopup(false)} />}

        {/* horizontal Divider        */}
        {/* <div className="row mb-3" style={{ margin: "0px 0px 0px 0px", width: "99%", borderBottom: '1px solid black', borderRadius: '5px!important' }} >
        </div> */}

    </>
}